<template>
    <article class="studio-page page type-page status-publish hentry">
        <header class="entry-header"  v-lazy:background-image="'https://api.alt-design.net/api/image/' + page.header_image[randomImage]" >
            <p class="sectors">{{ page.sub_title }}</p>
            <h1 class="entry-title">{{ page.title || 'About' }}</h1>
        </header><!-- .entry-header -->
        <div class="entry-content">

            <h2 class="alt-title">Friendly, Down-to-earth, Honest.</h2>

            <p class="sub-title">We design things that look good, and develop ideas that work.</p>

            <div class="cols">
                <div class="col left">
                    <p class="intro">We pride ourselves on long lasting client relationships. We may have the numbers of a small studio, but we certainly don’t think small.</p>
                </div>
                <div class="col right">
                    <p>Midlands based, we enjoy a real mix of clients, from local boutiques and businesses to multinational big hitters. Evolving from one, to many over the past decade, we’re a talented team with broad scope, both technical and creative, who offer professional bespoke brand, print and digital services.</p>
                </div>
            </div>

            <h2 class="alt-title">Meet The Team</h2>
            <div class="team team-grid">
                <div v-for="person of people" class="person" :class="person.shape">
                    <div class="content">
                        <div class="front" :style="{color: person.fontColor, backgroundColor: person.bgColor}" style="color: #FFFFFF; background-color: #000000;"><span>{{ person.name }}</span></div>
                        <div class="back" :class="'image-'+person.file"></div>
                    </div>
                </div>
                <div class="person empty" v-for="n in people.length % 4"></div>
            </div>

            <div class="services">
                <h2 class="alt-title">So what can we do?</h2>
                <p class="intro wrapper" style="text-align: center">
                    Whether it’s branding from scratch for a small start-up company with great ideas or a reliable e-commerce store for multinational brands with big plans, we have the expertise to help you achieve the best creative solution.
                </p>
                <div class="links wrapper">
                    <div class="team team-grid">
                        <router-link to="/about/branding" class="person circle">
                            <div class="content">
                                <div  class="front"  style="color: #FFFFFF; background-color: #FF6C00;"><span>Branding</span></div>
                                <div class="back back-branding"></div>
                            </div>
                        </router-link>
                        <router-link to="/about/print" class="person circle">
                            <div class="content">
                                <div  class="front"  style="color: #FFFFFF; background-color: #FF6C00;"><span>Print</span></div>
                                <div class="back back-print"></div>
                            </div>
                        </router-link>
                        <router-link to="/about/digital" class="person circle">
                            <div class="content">
                                <div  class="front"  style="color: #FFFFFF; background-color: #FF6C00;"><span>Digital</span></div>
                                <div class="back back-digital"></div>
                            </div>
                        </router-link>
                    </div>
                </div>



            </div>

            <div class="gallery">
                <div class="row bottom">
                    <div class="left equal animateIn"> <img v-lazy="'https://api.alt-design.net/api/image/' + page.work_image[0]"></div>
                    <div class="right equal animateIn"><img v-lazy="'https://api.alt-design.net/api/image/' + page.work_image[1]"/></div>
                </div>
                <div class="row top">
                    <div class="left wide animateIn"><img v-lazy="'https://api.alt-design.net/api/image/' + page.work_image[2]"/></div>
                    <div class="right narrow animateIn"><img v-lazy="'https://api.alt-design.net/api/image/' + page.work_image[3]"/></div>
                </div>
            </div>

        </div>

    </article>
</template>

<script>
  export default {
    data () {
      return {
        page: '',
        randomImage: 0,
        people: [
          {name: 'Will', file: 'will', shape: 'circle', bgColor: '#000', fontColor: '#FFF'},
          {name: 'Rebecca', file: 'rebecca', shape: 'circle', bgColor: '#DEC4A5', fontColor: '#0E2969'},
          {name: 'John', file: 'john', shape: '', bgColor: '#DCAB33', fontColor: '#FFFFFF'},
          // {name: 'Alan', file: 'alan', shape: '', bgColor: '#799DAD', fontColor: '#000000'},
          {name: 'Ben', file: 'ben', shape: '', bgColor: '#FF6600', fontColor: '#FFFFFF'},
          {name: 'Garry', file: 'garry', shape: 'circle', bgColor: '#222946', fontColor: '#FFFFFF'},
          {name: 'Rob', file: 'rob', shape: '', bgColor: '#D12828', fontColor: '#F2D600'},
          {name: 'Tom', file: 'tom', shape: 'circle', bgColor: '#00CEFF', fontColor: '#FFFFFF'},
          {name: 'Alan', file: 'alanc', shape: '', bgColor: '#c6d73f', fontColor: '#FFFFFF'},
          {name: 'Bec', file: 'bec', shape: 'circle', bgColor: '#F5C573', fontColor: '#932A35'}
        ]
      }
    },
    created () {
      window.api.get('get-pages/about').then(res => {
        this.page = res.data.data.page
        this.randomImage = Math.floor(Math.random() * this.page.header_image.length)
      })
      window.api.get('get-pages-by-type/2').then(res => {
        this.projects = res.data.data
      }).then(() => {
        this.$setTweens()
      })
      this.$setSeo('Website Design and Graphic Designers based in the midlands - Derby - UK | Alt Design', 'Design Consultancy and web design, graphic design and logo design in Derby')
    },
    mounted () {
      this.animateTeam()
    },
    methods: {
      animateTeam () {
        let triggered = false

        window.addEventListener('scroll', () => {
          let entryHeader = document.querySelector('.team-grid').getBoundingClientRect()
          let windowHeight = window.screen.height

          if (entryHeader.top <= (windowHeight / 2)) {
            if (!triggered) {
              triggered = true

              let teamMembers = document.querySelectorAll('.team .person')

              Array.prototype.forEach.call(teamMembers, function (el, index) {
                var that = el
                index = index + 1

                setTimeout(function () {
                  that.classList.toggle('hover')
                }, 150 * index)

                setTimeout(function () {
                  that.classList.toggle('hover')
                }, 750 + (150 * index))
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pages/About.vue